/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess'),

    // Locale bar
    localeBarFound: false,
    localeBarMaxTries: 0
  };
};

timber.init = function () {
  timber.cacheSelectors();
  timber.browserLanguage();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.apiFetch();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  timber.accordion();
  timber.collectionSlider();
  timber.collectionThumbs();
  timber.thumbnails();
  timber.langSelector();
  timber.getSize();
  timber.search();
  timber.trackProducts();
  timber.storeLocator();
  timber.mobileNavSearch();
  timber.slidingPuzzle();
  timber.valentineBundle();
  timber.productsSlider();
  timber.imageProducts();
  // timber.easter();
};

timber.easter = function () {
  var $modal = $('#hide-and-seek-modal');
  const modalTrigger = document.querySelector('.js-modal-trigger');

    // if modalTrigger is clicked add class to modal
    modalTrigger.addEventListener('click', () => {
      $modal.addClass('modal--active');
    });

    $modal.find('.modal__close, .modal__va-m').click(function(e) {
      if ($(e.target).is('a')) {
        return true;
      }

      if (
        $(e.target).hasClass('modal__content') ||
        $(e.target).parents('.modal__content').length !== 0
      ) {
        return false;
      }

      $modal.removeClass('modal--active');
    });

    function setCookie(cname,cvalue,exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = "expires=" + d.toGMTString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    let cookie = getCookie("easter-start");

    if (cookie == "") {

      setTimeout(function() {
        $modal.addClass('modal--active');
      }, 2000);

      setCookie("easter-start", true, 1);

    }

};

timber.imageProducts = function() {

  const hotspotButtons = document.querySelectorAll('.js-banner-hotspot');

  hotspotButtons.forEach(hotspotButton => {
    hotspotButton.addEventListener('click', () => {

      const hotspot = hotspotButton.getAttribute('data-hotspot');

      const allHotspotProducts = document.querySelectorAll('.banner-hotspot__product');
      var hasActive = false;

      allHotspotProducts.forEach(allHotspotProduct => {
        if (allHotspotProduct.classList.contains("active")) {
          hasActive = true;
        }

        if (hasActive) {

          if (allHotspotProduct.getAttribute('data-hotspot') != `product-${hotspot}`) {
            allHotspotProduct.classList.remove("active");
          }

        }
      });

      const hotspotProducts = document.querySelectorAll(`[data-hotspot='product-${hotspot}']`);

      hotspotProducts.forEach(hotspotProduct => {

        if (hotspotProduct.classList.contains("active")) {
          hotspotProduct.classList.remove("active");
        } else {
          hotspotProduct.classList.add("active");
        }
      });

    });
  });

};

timber.productsSlider = function() {

  /* Slick needs no get Reinitialized on window Resize after it was destroyed */
  $(window).on('load', function() {
    $('.product-slider').each(function() {
      var $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      $carousel.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        swipeToSlide: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: true,
              variableWidth: false,
              swipeToSlide: true,
              centerMode: false,
            }
          }
        ]
      });
    });
  });

};

timber.valentineBundle = function () {

  var yourBoxer;
  var belovedBoxer;
  var yoursSizeSelects = $('.js-product-select-yours');
  var belovedSizeSelects = $('.js-product-select-beloved');

  $('.js-yours-input').click(function() {
    if ($(this).is(':checked')) {
      const label = $(this).next();

      yourBoxer = label.find('.js-product-select-yours').val();
    }
  });

  $('.js-beloved-input').click(function() {
    if ($(this).is(':checked')) {
      const label = $(this).next();

      belovedBoxer = label.find('.js-product-select-beloved').val();
    }
  });

  //check size selects on change

  yoursSizeSelects.each(function( index ) {
    $(this).on('change', function() {

      var variantId = $(this).val();
      var productSize = $(this).parents('.grid__item ').find('.js-yours-input');

      productSize.prop("checked", true);

      if (productSize.is(':checked')) {
        yourBoxer = variantId;
      }
    });
  });

  belovedSizeSelects.each(function( index ) {
    $(this).on('change', function() {

      var variantId = $(this).val();
      var productSize = $(this).parents('.grid__item ').find('.js-beloved-input');

      productSize.prop("checked", true);

      if (productSize.is(':checked')) {
        belovedBoxer = variantId;
      }
    });
  });

  //check if radio button is selected
  $(document).ready(function(){
    $('.js-valentine-add-to-cart').click(function() {
      if (!$(".js-yours-input:checked").val() || !$(".js-beloved-input:checked").val()) {
         alert('You need to select two boxers');
          return false;
      }
      else {
        jQuery.ajax({
          url:'/cart/add.js',
          type: 'post',
          dataType: 'json',
          data: {
            items: [
              {
                quantity: 1,
                id: belovedBoxer
              },
              {
                quantity: 1,
                id: yourBoxer
              }
            ]
           },
           complete: function() {
            console.log("completed");
            $('.js-drawer-open-right').click();
          }
        })

      }
    });
  });

};

timber.slidingPuzzle = function () {

  var settings = {
    rows: 3,                    // number of rows [3 ... 9]
    cols: 3,                    // number of columns [3 ... 9]
    hole: 9,                   // initial hole position [1 ... rows*columns]
    shuffle: true,             // initially show shuffled pieces [true|false]
    numbers: false,              // initially show numbers on pieces [true|false]
    language: 'en',             // language for gui elements [language code]

    // display additional gui controls
    control: {
        shufflePieces: false,    // display 'Shuffle' button [true|false]
        confirmShuffle: true,   // ask before shuffling [true|false]
        toggleOriginal: true,   // display 'Original' button [true|false]
        toggleNumbers: false,    // display 'Numbers' button [true|false]
        counter: true,          // display moves counter [true|false]
        timer: true,            // display timer (seconds) [true|false]
        pauseTimer: true        // pause timer if 'Original' button is activated
                                // [true|false]
    },

    // perform actions when the puzzle is solved sucessfully
    success: {
        fadeOriginal: false,    // cross-fade original image [true|false]
        callback: function(results) {
          $(".sliding_puzzle_time").val(results.seconds);
          $(".sliding-puzzle__succes").removeClass("vh");
        },
                                // which includes the fields 'moves' and 'seconds'
        callbackTimeout: 300    // time in ms after which the callback is called
    },

    // animation speeds and settings
    animation: {
        shuffleRounds: 3,       // number of shuffle rounds [1 ... ]
        shuffleSpeed: 800,      // time in ms to perform a shuffle round
        slidingSpeed: 200,      // time in ms for a single move
        fadeOriginalSpeed: 600  // time in ms to cross-fade original image
    },

    // additional style information not specified via css
    style: {
        gridSize: 2,            // space between two pieces in px
        overlap: true,          // if true, adjacent piece borders will overlap
                                // applies only if gridSize is set to 0
        backgroundOpacity: 0.1  // opacity of the original image behind the pieces
                                // [0 ... 1] (0 means no display)
    }
  }

  $('.sliding-puzzle').jqPuzzle(settings); // apply to all images


};

timber.browserLanguage = function () {
  var isBot = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
  var browserLang = navigator.language.split('-').shift();
  var storageLang = localStorage.getItem('user-lang');
  var documentLang = document.documentElement.lang;

  if (!isBot) {
    if (!storageLang) {
      localStorage.setItem('user-lang', browserLang);

      if (documentLang !== browserLang) {
        // Redirect to browser language when it's not the document language
        timber.redirectFromAlterateLink(browserLang);
      }
    } else if (documentLang !== storageLang) {
      // Redirect to preferred language when it's not the same as the document language
      timber.redirectFromAlterateLink(storageLang);
    }
  }

  setTimeout(function() {
    var langList = document.querySelectorAll('.polyglot-selector__list a');
    console.log(langList);
    langList.forEach(list => {
      list.addEventListener('click', function() {
        localStorage.setItem('user-lang', list.innerHTML);
      });
    });
  }, 1000);

  setTimeout(timber.languageRedirectLocaleBar, 500);
};

timber.redirectFromAlterateLink = function(lang) {
  var hostDomain = window.location.host.split('.').pop();
  var alternateLinks = document.querySelectorAll('link[rel="alternate"]');
  var langRegionSuffix = "-".concat(hostDomain === 'uk' ? 'GB' : hostDomain.toUpperCase());
  var redirectUrl;

  // Find alternative link from the current language in combination with the current domain
  for (var i = 0; i < alternateLinks.length; i += 1) {
    var link = alternateLinks[i];
    if (link.hreflang.includes('-') && !link.hreflang.includes('x-default')) {
      // check if alternate link has multiple domains, contains -DOMAINNAME
      var langHostDomain = lang + langRegionSuffix;
      if (link.hreflang === langHostDomain) {
        redirectUrl = link.href;
        break;
      }
    }
  }

  if (!redirectUrl) {
    // If no link is found, try again with the current language
    for (var i = 0; i < alternateLinks.length; i += 1) {
      var link = alternateLinks[i];

      // Add check if alternate link is on the same domain
      var isSameDomain = link.href.indexOf(`.${hostDomain}/`) > -1;

      if (link.hreflang === lang && isSameDomain) {
        redirectUrl = link.href;
        break;
      }
    }
  }

  if (redirectUrl) {
    window.location.assign(redirectUrl);
  }
}

// Add geo redirect bar locale to local storage
timber.languageRedirectLocaleBar =  function() {
  var localeBarButton = document.querySelector('.locale-bar__button');
  if (localeBarButton && !timber.cache.localeBarFound) {
    timber.cache.localeBarFound = true;

    var localeBarSelect = document.querySelector('.locale-bar__selector');
    if (localeBarSelect) {
      localeBarButton.addEventListener('click', function() {
        var localeValue = localeBarSelect.value;
        localStorage.setItem('user-lang', localeValue);
      });
    }
  } else if (timber.cache.localeBarMaxTries < 10) {
    timber.cache.localeBarMaxTries += 1;
    setTimeout(timber.languageRedirectLocaleBar, 500);
  }
}

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  timber.RightDrawerCustom = new timber.Drawers('SizeguideDrawer', 'right-custom');
  
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.apiFetch = function () {
  var truncate = function (text) {
    var string = text.substring(0, 120);
    if (text.length > 120) {
      string += '&hellip;'
    }

    return string;
  };

  $('.js-api-fetch').each(function() {
    var $this = $(this);
    var api = $this.data('api');
    var limit = $this.data('limit'); // optional limitation
    var itemClass = $this.data('item-class');

    $.get(api, function (data) {
      var loopableObject = data.data ? data.data : data;
      if (loopableObject) {
        // get length of files
        var length = limit ? limit : loopableObject.length;
        var items = '';

        for (var i = 0; i < length; i++) {
          var el = loopableObject[i];
          if (el.media_type === 'video') {
            items += '<div class="' + itemClass + '">' +
              '<div class="social-item-link">'+
                '<video width="260" height="260" autoplay loop muted class="social-item-link__image"><source src="' +
                el.photo +
                '" type="video/mp4"></video>' +
              '</div>' +
            '</div>';
          } else {
            items += '<div class="' + itemClass + '">' +
              '<a href="' + el.url + '" target="_blank" class="social-item-link">' +
                '<img src="' + el.photo + '" class="social-item-link__image" />' +
              '</a>' +
            '</div>';
          }
        }

        $this.html(items);
      }
    });
  });
};

timber.accordion = function () {
  $('.accordion__title').click(function(e) {
    e.preventDefault();
    $(this).toggleClass('active').next('.accordion__content').toggle('fast');
  });
};

timber.collectionSlider = function() {

  /* Slick needs no get Reinitialized on window Resize after it was destroyed */
  $(window).on('load', function() {
    $('.collection-items').each(function() {
      var $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      $carousel.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        swipeToSlide: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: true,
              variableWidth: false,
              swipeToSlide: true,
              centerMode: false,
            }
          }
        ]
      });
    });
  });

};

timber.collectionThumbs = function() {

  /* Slick needs no get Reinitialized on window Resize after it was destroyed */
  $(window).on('load', function() {
    $('.collection-thumbs').each(function() {
      var $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      $carousel.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        swipeToSlide: true,
        arrows: false,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: true,
              variableWidth: false,
              swipeToSlide: true,
              centerMode: false,
            }
          }
        ]
      });
    });
  });

};

timber.thumbnails = function() {

  $('.product-single__thumbnails li').click(function() {
    $('.product-single__thumbnails li').removeClass('active');
    $(this).addClass('active');
  });

};

timber.langSelector = function() {
  $('.lang-selector__trigger').click(function(){
    var $langWrapper = $(this).parents('.lang-selector');
    $langWrapper.toggleClass('open');
    $langWrapper.find('.lang-selector__list').toggle();
  });
};

timber.getSize = function() {

  if ($('.template-product').length) {
    var size = getUrlParameter('size');
    if (size != undefined) {
      /* Make sure to set the right value (lowercase or uppercase) */
      $("#productSelect-option-0 option[value=" + size + "]").attr('selected','selected');
      $("#productSelect-option-0 option[value=" + size.toLowerCase() + "]").attr('selected','selected');
      $("#productSelect-option-0 option[value=" + size.toUpperCase() + "]").attr('selected','selected');

      $("#productSelect-option-0").change();
    };
  }

};

timber.search = function() {

  $('form[action="/search"]').submit(function(e) {
    // e.preventDefault();
    var $searchInput = $(this).find('input[name="q"]');
    var value = $searchInput.val();

    if (value.length > 0 && value[value.length - 1] !== '*') {
      value += '*';
      $searchInput.val(value);
    }
  });

};

timber.trackProducts = function() {
  $('.js-track-products').on('click', 'a', function(e) {
    var $this = $(this);
    var pathnameArr = window.location.pathname.split('/');
    var category = pathnameArr[pathnameArr.length - 1].replace('-', ' ');
    var categoryText = category + ' - view product';
    var product = $this.attr('href').replace('/products/', '');
    //$this.closest('.product-item').find('img').attr('alt');

    if (ga) {
      ga('send', 'event', categoryText, 'click ' + product, product);
    }
  });
};

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

timber.mobileNavSearch = function () {
  var searchTrigger = $('.js-mobile-nav-search-trigger');
  var search = $('.js-mobile-nav-search');

  searchTrigger.on('click', function (e) {
    search.css("opacity", "1");
    e.stopPropagation();
  });

  search.on('click', function (e) {
    e.stopPropagation();
  });

  $(document).click(function(){
    search.css("opacity", "0");
  });

};

// timber.cartPage = function () {
//   var $cartCheckout = $('.cart button[name="checkout"]');

//   if ($cartCheckout && $cartCheckout.length > 0 &&
//     window.variationDiffers && window.variationDiffers === true) {

//     var cartConfirm = false;

//     $cartCheckout.click(function(e) {
//       if (!cartConfirm) {
//         e.preventDefault();
//         var modal = $('[data-remodal-id="cart-variations-modal"]').remodal({
//           hashTracking: false
//         });

//         modal.open();
//       }
//     });

//     $(document).on('confirmation', '.remodal--variations', function () {
//       cartConfirm = true;
//       $cartCheckout.trigger('click');
//     });
//   }
// };

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html($('#products_product_add_to_cart').html());
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html($('#products_product_sold_out').html());
      //$quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html($('#products_product_compare_at').html() + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html($('#products_product_unavailable').html());
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  //$el.attr('src', src);
  $el.css('background-image', 'url(' + src + ')');
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
 if (timber.cache.$changeView.length) {
   timber.cache.$changeView.on('click', function() {
     var view = $(this).data('view'),
         url = document.URL,
         urlWithoutHash = url.split('#')[0],
         hasParams = url.indexOf('?') > -1,
         location = '';

     if (hasParams) {
       location = replaceUrlParam(urlWithoutHash, 'view', view);
     } else {
       location = urlWithoutHash + '?view=' + view;
     }

     if(url.indexOf('#') > -1) {
       var hash = url.substring(url.indexOf('#')+1);
       location += '#' + hash;
     }

     window.location = location;
   });
 }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

timber.storeLocator = function () {
  var $storeLocator = $('#col-main');

  if ($storeLocator.length) {
    var $submitButton = $('#submitBtn');

    $('#store-locator-title').replaceWith(function () {
      return '<h1 id="store-locator-title">' + $(this).html() + '</h1>';
    });

    $('#store-locator-title').insertBefore($('.main_search_label'));
    $submitButton.html('<i class="icon icon-arrow" aria-hidden="true"></i><span class="vh">Search</span>');
    $storeLocator.children(':not(.footer_html:last-child)').wrapAll('<div class="store-locator-wrap"></div>');
    $storeLocator.find('.search_bar').addClass('ready');

    $('#within_distance').html('<option value="50" selected="selected">50 KM</option>');
    $('#limit').html('<option value="6" selected="selected">6</option>');

    if (window.location.host === 'fr.mcalson.com') {
      $('.js-fr-selected-retailers').html('Boutiques sélectionées');
      $('.js-fr-email').attr('placeholder', 'Votre adresse mail');
      $('.js-fr-more').html('En savoir plus');

      $('#store-locator-title').html('Recherchez un détaillant');
      $('.main_search_label').html('Trouvez un détaillant pres de chez vous');

      $('#address_search').attr('value', 'Code postal, ville');
      $('#address_search').attr('onfocus', 'if(this.value==\'Code postal, ville\'){this.value=\'\'}');
      $('.no_stores_found').html('Dites-nous où vous habitez et trouvez des emplacements près de chez vous.')
    }
  }
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);
